const localization = {
    cannot_delete_default_language: '{{languageTag}} è impostato come la tua lingua predefinita e non può essere eliminato.',
    invalid_translation_structure: "Schemi di dati non validi. Controlla l'input e riprova.",
};
export default localization;
